export const DIMS = [
  ["script_adherence", "Script"],
  ["compliance", "Compliance"],
  ["empathy", "Empathy"],
  ["objection_handling", "Objections"],
  ["clarity", "Clarity"],
  ["resolution", "Resolution"],
];

export const MOODS = ["angry", "frustrated", "annoyed", "confused", "neutral", "calm", "interested", "pleased"];
export const moodScore = (m) => Math.max(1, MOODS.indexOf(m) + 1);

export const MOOD_COLOR = {
  angry: "#F87171", frustrated: "#FB923C", annoyed: "#FBBF24", confused: "#A78BFA",
  neutral: "#94A3B8", calm: "#67E8F9", interested: "#34D399", pleased: "#4ADE80",
};

export const VERDICT = {
  "Pilot Ready": { color: "#34D399", bg: "rgba(52,211,153,0.12)" },
  "Needs Work": { color: "#FBBF24", bg: "rgba(251,191,36,0.12)" },
  "Not Ready": { color: "#F87171", bg: "rgba(248,113,113,0.12)" },
};
export const verdictStyle = (v) => VERDICT[v] || { color: "#94A3B8", bg: "rgba(148,163,184,0.12)" };

export const scoreColor = (s, max = 10) => {
  const p = s / max;
  if (p >= 0.75) return "#34D399";
  if (p >= 0.5) return "#FBBF24";
  return "#F87171";
};

export const SEVERITY = {
  critical: { color: "#F87171", label: "Critical" },
  major: { color: "#FBBF24", label: "Major" },
  minor: { color: "#67E8F9", label: "Minor" },
};

export const DIFFICULTY = { easy: "#34D399", medium: "#FBBF24", hard: "#FB923C", brutal: "#F87171" };

export const STATUS = {
  queued: { label: "Queued", color: "#94A3B8" },
  running: { label: "Live", color: "#22D3EE" },
  judging: { label: "Judging", color: "#8B5CF6" },
  completed: { label: "Done", color: "#34D399" },
  failed: { label: "Failed", color: "#F87171" },
};

export const fmtDate = (iso) => new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
export const titleCase = (s) => (s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
